import { PolicyStatusColors } from 'policy-management/policy-details/views/policy-status-display';

export enum BANVStatus {
  Pending = 'pending',
  Processing = 'processing',
  Verified = 'verified',
  FailedVerification = 'failed_verification',
  Blocked = 'blocked',
}

export const prettyBANVStatus = (status: BANVStatus) => {
  switch (status) {
    case BANVStatus.Processing:
      return 'Verifying';
    case BANVStatus.Verified:
      return 'Verified';
    case BANVStatus.FailedVerification:
      return 'Failed verification';
    case BANVStatus.Blocked:
      return 'Blocked';
    default:
      return 'Pending';
  }
};

export const verificationBANVStatus = (status: BANVStatus) => {
  switch (status) {
    case BANVStatus.Processing:
      return 'Processing';
    case BANVStatus.Verified:
      return 'Valid';
    case BANVStatus.FailedVerification:
      return 'Invalid';
    case BANVStatus.Blocked:
      return 'Invalid';
    default:
      return 'Pending';
  }
};

export const banvStatusColorMapping = (
  status: BANVStatus,
  siteConfig: any, // Using 'any' for siteConfig type for simplicity, adjust if a more specific type is available
) => {
  const mapping = {
    [BANVStatus.Verified]: siteConfig?.styles?.colors?.banvStatusVerified || PolicyStatusColors.Success,
    [BANVStatus.Pending]: siteConfig?.styles?.colors?.banvStatusPending || PolicyStatusColors.Warning,
    [BANVStatus.Processing]: siteConfig?.styles?.colors?.banvStatusProcessing || PolicyStatusColors.Warning,
    [BANVStatus.FailedVerification]: siteConfig?.styles?.colors?.banvStatusFailed || PolicyStatusColors.Danger,
    [BANVStatus.Blocked]: siteConfig?.styles?.colors?.banvStatusBlocked || PolicyStatusColors.Danger,
  };

  return mapping[status] || PolicyStatusColors.Warning; // Default to warning if status somehow not in map
};
